import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/stores/auth.store';
import { ProtectedRoute } from './ProtectedRoute';

interface AdminRouteProps {
  children: React.ReactNode;
}

export function AdminRoute({ children }: AdminRouteProps) {
  const user = useAuthStore((s) => s.user);
  const location = useLocation();

  return (
    <ProtectedRoute>
      {user?.role === 'ADMIN' ? (
        children
      ) : (
        <Navigate to="/" state={{ from: location }} replace />
      )}
    </ProtectedRoute>
  );
}
